import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';

export default function BridgeLayout({ title, canGoBack, onBack, onHome, children }) {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <header className="sticky top-0 z-20 bg-white border-b border-gray-200">
        <div className="h-12 px-2 flex items-center gap-2">
          {canGoBack ? (
            <button
              type="button"
              onClick={onBack}
              className="h-9 w-9 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 flex items-center justify-center text-gray-600"
              title="Voltar"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
          ) : (
            <button
              type="button"
              onClick={onHome}
              className="h-9 w-9 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 flex items-center justify-center text-gray-600"
              title="Início"
            >
              <Home className="w-4 h-4" />
            </button>
          )}

          <div className="min-w-0 flex-1">
            <div className="text-[11px] font-bold text-gray-700 truncate">{title}</div>
            <div className="text-[9px] uppercase font-bold text-gray-400 tracking-wider truncate">RDA Studio</div>
          </div>
        </div>
      </header>

      <main className="px-2 py-2">
        {children}
      </main>
    </div>
  );
}